import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import style from './style.module.less'
import { ctrlTextLen } from '@hlj/hlj-utils'
import { dGet } from '@core/utils'
import { COLOR_BLUE } from '@constant'
import Img from '@UI/Img'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const {
      author,
      comment_photos,
      comment_video,
      reply_comments,
      created_at,
      rating,
      content,
      decorationStore: { themeConfig, isThemeBlackGold }
    } = this.props

    const videoPath = dGet(comment_video, 'cover_path')

    return (
      <div
        className={style.item}
        style={{ borderBottom: `1px solid ${themeConfig['line']}` }}
      >
        <div className={style.user}>
          <Img
            src={dGet(author, 'avatar') || dGet(author, 'default_avatar')}
            style={{ width: 40, height: 40 }}
          />

          <div className={style.info}>
            <p>{dGet(author, 'nick')} </p>
            <p>
              <span>{created_at}</span>
              <span style={{ margin: '0 4px' }}>｜</span>
              <span style={{ color: themeConfig['text'] }}>{rating}星</span>
            </p>
          </div>
        </div>

        <p className={style.content}>{content}</p>

        <div className={style.photo}>
          {videoPath && (
            <div className={style.photoWrapper}>
              <Img src={videoPath} className={style.photoVideo} />
              <img
                src="//qnm.hunliji.com/o_1cnbhtmk6iu515pf1drl1v991aqa9.png"
                className="center"
              />
            </div>
          )}
          {(comment_photos || []).map((item, index) => (
            <div className={style.photoWrapper} key={index}>
              <Img src={item.photo_path} className={style.photoVideo} />
            </div>
          ))}
        </div>

        {reply_comments.length > 0 && (
          <div
            className={style.commentList}
            style={{
              backgroundColor: themeConfig['homeBg']
            }}
          >
            {(reply_comments || []).map(item => {
              return (
                <div key={item.id} className={style.commentItem}>
                  <div
                    style={{
                      color: isThemeBlackGold
                        ? themeConfig['text']
                        : COLOR_BLUE,
                      maxWidth: 100,
                      flexShrink: 0
                    }}
                  >
                    {ctrlTextLen(dGet(item, 'user.nick'), '6', '...')}
                  </div>
                  <div>：{item.content}</div>
                </div>
              )
            })}
          </div>
        )}
      </div>
    )
  }
}
